// ------------------------------------
// Constants
// ------------------------------------
export const SERVICES_GET_REQUEST = "SERVICES_GET_REQUEST";
export const SERVICES_GET_REQUEST_SUCCESS = "SERVICES_GET_REQUEST_SUCCESS";
export const SERVICES_GET_REQUEST_FAILURE = "SERVICES_GET_REQUEST_FAILURE";
export const SERVICES_GET_RESET = "SERVICES_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(params) {
  return {
    type: SERVICES_GET_REQUEST,
    params,
  };
}

export function requestSuccess(data, params) {
  return {
    type: SERVICES_GET_REQUEST_SUCCESS,
    data,
    params,
  };
}

export function requestFailure(error, params) {
  return {
    type: SERVICES_GET_REQUEST_FAILURE,
    error,
    params,
  };
}

export function reset() {
  return {
    type: SERVICES_GET_RESET,
  };
}
